import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import { Area } from '@/enums/Area.enum';
import { LayerName } from '@/enums/LayerName.enum';
import { Style, Fill } from 'ol/style';
import { STROKE_WHITE_W05 } from '@/utils/constants.utils';

// Used for 30 arcsec grid
export const nestedLayer = new VectorLayer({
  source: new VectorSource(),
  style: function (feature) {
    return new Style({
      fill: new Fill({
        color: feature.get('color') // get the per-feature color
      }),
      stroke: STROKE_WHITE_W05
    })
  }
});

nestedLayer.setProperties({ area: Area.NESTED, name: LayerName.NESTED });
